import FileSaver from 'file-saver';
import axios from 'axios';
import 'json.date-extensions/json.date-extensions.js';


export const apiRequest = (url, options = {}) => {

  const config = {
    url,
    method: options.method || 'get',
    responseType: options.responseType || 'json',
    headers: options.headers || {},
    transformResponse: [function(data) {
     // console.log("data",data);
      return JSON.parseWithDate(JSON.stringify(data));
    }]
  };
  config.headers['Content-Type'] = options.contentType || 'application/json';

  if (options.data) {
    if (options.formData) {
      let fd = new FormData();
      fd.append(options.fieldName || 'file', options.data);
      config.data = fd;
    } else {
      if (!options.contentType) {
        config.data = JSON.stringify(options.data);
      }
      else {
        config.data = options.data;
      }
    }
  }

  return axios(config)
    .then(response => {
    //  console.debug("response", response);
      return response.data !== undefined ? response.data : response;
    })
    .catch(() => {
      return {
        error: {
          code: -1,
          message: 'Villa kom upp.'
        }
      };
    });
};

export const fetchPdfBinary = (url, filename) => {
  apiRequest(url).then(data => {
    if (data !== undefined && data !== null) {
      let ab = base64ToArrayBuffer(data);
      let blob = new Blob([ab], { type: 'application/pdf' });
      FileSaver.saveAs(blob, `${filename}.pdf`);
    }
  });
};

const base64ToArrayBuffer = base64 => {
  let binaryString = window.atob(base64);
  let binaryLen = binaryString.length;
  let bytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i++) {
    let ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
};



// WEBPACK FOOTER //
// ./src/api/ApiRequest.js